import { create } from "zustand";
import { devtools } from "zustand/middleware";

export const useAuth2fa = create(
    devtools((set) => ({
        email: null,
        clear: () => set(() => ({ email: null })),
        set_email: (email) => set(() => ({ email: email })),
    }))
);
